import { Navigate, useLocation, useParams } from 'react-router-dom';

const ChartRedirect = ({ to, keepRest = true }) => {
  const params = useParams();
  const { pathname, search, state } = useLocation();
  const chartSegment = `/charts/${params.id}`;
  const chartBase = pathname.slice(0, pathname.indexOf(chartSegment) + chartSegment.length);
  const resolvedTo = to.replace(/:(\w+)/g, (_, key) => params[key] ?? '');
  const target = [resolvedTo, keepRest && params['*']].filter(Boolean).join('/');

  return <Navigate to={`${chartBase}/${target}${search}`} state={state} replace />;
};

export default ChartRedirect;
